<template>
  <div class="event">
    <!-- Filter -->
    <FilterFrame
      ref="filter"
      :filter-form="outputEventFilterStructure"
      class="filter-frame"
      @search="search"
      @clear="clearSearch()"
    />
    <div class="function">
      <el-button
        class="analysis"
        round
        @click="openAnalysis"
      >
        告警事件分析
      </el-button>
    </div>
    <!-- Table -->
    <el-table
      :data="resultData"
      style="width: 100%"
    >
      <el-table-column
        label="#"
        type="index"
        width="50"
      />
      <el-table-column
        v-for="[key, value] of Object.entries(eventStructure) "
        :key="key"
        :prop="key"
        :label="value"
        :width="key === 'CreatedTime' || key === 'DoneTime' ? '110px':'auto'"
      >
        <template slot-scope="scope">
          <pre v-if="key === 'EventStatus'" :class="{emergency: scope.row['TagLevel'] === 'L4-災害級警報' && !scope.row[key] , warning: scope.row['TagLevel'] === 'L3-高程度警報' && !scope.row[key] }"> {{ scope.row[key] ? '正常' : '異常' }}</pre>
          <pre v-else-if="key === 'IsPrivate'"> {{ scope.row[key] ? '私區' : '公區' }}</pre>
          <pre v-else class="regular" :class="{emergency: scope.row[key] === 'L4-災害級警報', warning: scope.row[key] === 'L3-高程度警報'}">{{ scope.row[key] || '-' }}</pre>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
      >
        <template slot-scope="scope">
          <div class="operate">
            <el-button v-if="!scope.row.CurrentStageType.includes('結案')" size="mini" type="text" @click="handleClickReport(scope.row.EventId, scope.row.IsPrivate?'private':'public')">
              回報
            </el-button>
            <el-button size="mini" type="text" @click="handleClickEventDetail(scope.row.EventId, scope.row.IsPrivate?'private':'public')">
              檢視
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <TableLoading :is-loading="isLoading" />
  </div>
</template>

<script>
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame'
import { eventStructure, eventFilterStructure } from '../models'
import { todayISOString, lastMonthISOString, processEventList, processFilterOptions } from '../utils'

export default {
  components: {
    FilterFrame,
    TableLoading
  },
  props: {
    assetCategoryDataOptions: Array
  },
  data () {
    const maxCount = 10
    const defaultReq = {
      // 無 L0
      TagLevelList: [1, 2, 3, 4],
      StageTypeList: [0, 1, 2, 3, 4],
      'CreateInterval.StartAt': lastMonthISOString,
      'CreateInterval.EndAt': todayISOString,
      MaxCount: maxCount,
      IsPrivate: 'null'
    }
    const req = defaultReq
    const isLoading = true
    const isNoMoreList = false
    const outputEventFilterStructure = eventFilterStructure
    return {
      eventStructure,
      outputEventFilterStructure,
      inputEventList: [],
      defaultReq,
      req,
      isLoading,
      isNoMoreList,
      maxCount,
      filterQuery: {}
    }
  },
  computed: {
    resultData () {
      return processEventList(this.inputEventList)
    }
  },
  watch: {
    $route (to, from) {
      this.showEventReportOrDetailDialog()
    },
    assetCategoryDataOptions (nV, oV) {
      const obj = this.outputEventFilterStructure.find(el => el.name === 'AssetCategoryId')
      obj.options = nV
      obj.isDisable = false
    }
  },
  async mounted () {
    this.setDefaultSearchQuery()
    this.showEventReportOrDetailDialog()
    // 獲取資料（已移至 BA-alertView 呼叫）
    // 載入更多
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll)
    })
    // 測試用 打開第一筆詳細資料
    // this.handleClickEventDetail(this.resultData[1].EventId)
    // this.handleClickReport(this.resultData[1].EventId)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    setDefaultSearchQuery () {
      const query = this.$route.query
      if (query) {
        if (query.area) {
          const area = query.area
          const copyReq = JSON.parse(JSON.stringify(this.req))
          this.outputEventFilterStructure.forEach((item) => {
            if (item.name === 'IsPrivate') {
              if (area === 'public') copyReq.IsPrivate = item.value = 'false'
              else if (area === 'private') copyReq.IsPrivate = item.value = 'true'
              else copyReq.IsPrivate = item.value = 'null'
              this.req = copyReq
            }
          })
        }
      }
    },
    localUpdateEventRow (updateRowData) {
      this.inputEventList = this.inputEventList.map(el => {
        if (el.EventId === updateRowData.EventId) {
          const tempEl = { ...el }
          tempEl.CurrentStageType = updateRowData.CurrentStageType
          tempEl.CurrentStageRemark = updateRowData.CurrentStageRemark
          tempEl.StageList = updateRowData.StageList
          return tempEl
        }
        // 如果從 report/:id 進來應只有前十筆，若此 id 不在前十筆則不會更新到此資料沒關係
        return el
      })
    },
    async initEventList () {
      const req = this.req
      try {
        // 清空列表且呈現 loading 畫面
        this.inputEventList = []
        this.isLoading = true
        if (this.req.IsPrivate === 'null') delete this.req.IsPrivate
        const res = await apiBaAlert.getEvent(req)
        await this.$sleep(1000, res.duration)
        this.inputEventList = res.data
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
        this.isNoMoreList = false
      }
    },
    async getMoreEventList () {
      if (this.$route.name === 'baEvent' && !this.isLoading && !this.isNoMoreList && this.resultData.length > 0) {
        this.isLoading = true
        const req = {
          ...this.req,
          MaxId: this.resultData[this.resultData.length - 1].EventId
        }
        try {
          if (this.req.IsPrivate === 'null') delete this.req.IsPrivate
          const res = await apiBaAlert.getEvent(req)
          // 至少也載個一秒鐘啦～～～
          await this.$sleep(1000, res.duration)
          if (res.data.length < this.maxCount) {
            this.isNoMoreList = true
          }
          this.inputEventList = [
            ...this.inputEventList,
            ...res.data
          ]
          return true
        } catch (error) {
          console.log(error)
          await this.$sleep()
          return false
        } finally {
          this.isLoading = false
        }
      }
    },
    handleScroll (e) {
      this.$handleScroll(this.getMoreEventList)
    },
    closeEventReportAndDetailDialog () {
      this.$emit('closeEventReportAndDetailDialog')
    },
    showEventReportOrDetailDialog () {
      this.closeEventReportAndDetailDialog()
      this.$nextTick(() => {
        // 有指定事件的話
        if (this.$route.name === 'eventDetailById' || this.$route.name === 'privateEventDetailById') {
          this.handleClickEventDetail(this.$route.params.id, this.$route.name.includes('rivate') ? 'private' : 'public')
        } else if (this.$route.name === 'reportEventById' || this.$route.name === 'reportPrivateEventById') {
          this.handleClickReport(this.$route.params.id, this.$route.name.includes('Private') ? 'private' : 'public')
        }
      })
    },
    search (filterOptions) {
      this.req = processFilterOptions(filterOptions, this.defaultReq)
      if (this.req.IsPrivate === 'null') delete this.req.IsPrivate
      this.initEventList()
    },
    clearSearch () {
      this.req = this.defaultReq
      this.outputEventFilterStructure.forEach((item) => {
        if (item.name === 'IsPrivate') item.value = 'null'
      })
      this.initEventList()
    },
    handleClickReport (id, area) {
      this.$emit('handleClickReport', id, area)
    },
    handleClickEventDetail (id, area) {
      this.$emit('handleClickEventDetail', id, area)
    },
    openAnalysis () {
      this.$router.push({
        name: 'analysis'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.function {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.event {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
  .emergency {
    color: $dangerColor;
  }
  .warning {
    color: $systemBAOrange;
  }
  ::v-deep .el-table {
    @include basicTable();
    .cell {
      text-align: center;
    }
  }
}

.operate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  * {
    margin: 0;
  }
}
</style>
